import { useContext, useEffect } from 'react';
import useGet from '../http/useGet';
import apiMethods from '../../../apis';
import { useDispatch, useSelector } from 'react-redux';
import { setBusiness } from '../../../store/slices/user';
import Context from '../../../store/context';

const useUpdateBusiness = () => {
  const { businessId } = useSelector(state => state.userData);
  const {
    modal: { showError }
  } = useContext(Context);

  const dispatch = useDispatch();

  const {
    isSuccess: getBusinessSuccess,
    data: getBusinessData,
    isError: getBusinessError,
    errorMessage,
    refetch
  } = useGet(apiMethods.getBusiness, [businessId], false);

  useEffect(() => {
    if (getBusinessSuccess) {
      dispatch(setBusiness({ businessId, businessData: getBusinessData }));
    } else if (getBusinessError) {
      showError({ title: 'Información', description: errorMessage });
    }
  }, [businessId, dispatch, errorMessage, getBusinessData, getBusinessError, getBusinessSuccess, showError]);

  return {
    updateBusinessFetch: refetch
  };
};

export default useUpdateBusiness;
